const JPIDENTITYDOCUMENT = {
	StatementFromUnifiedRegisterOfLegalEntities: 'StatementFromUnifiedRegisterOfLegalEntities',
	StatementFromUnifiedRegisterOfIndividualEntrepreneurs:
		'StatementFromUnifiedRegisterOfIndividualEntrepreneurs',
	CertificateOfStateRegistration: 'CertificateOfStateRegistration',
	IndividualEntrepreneurRegistrationCertificate: 'IndividualEntrepreneurRegistrationCertificate',
};

export { JPIDENTITYDOCUMENT };
